import { OpenAPI } from "simplydo/interfaces";

import { API, APIError } from ".";

export const notifications = (api: API) => ({
  get(
    page: number,
    success: (data: OpenAPI.GET<"/notifications">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/notifications?page=${page}`,
      null,
      success,
      fail,
    );
  },
  markAsSeen(
    notificationIds: string[],
    markAllAsSeen: boolean,
    success: (data: OpenAPI.PUT<"/notifications/seen">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/notifications/seen`,
      { notifications: notificationIds, markAllAsSeen },
      success,
      fail,
    );
  },
  markAsInteracted(
    notification: string,
    success: (
      data: OpenAPI.PUT<"/notifications/{id}/interacted">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/notifications/${notification}/interacted`,
      null,
      success,
      fail,
    );
  },
});
